import { forwardRef } from 'react';

export const WaldIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110 110" ref={ref} {...props}>
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M77.4 51v39.5m-9.5-25.2c3 1.1 6.2 1.7 9.6 1.7C92.7 67 105 54.7 105 39.5S92.8 12.1 77.6 12.1c-9 0-17.1 4.4-22.1 11.1"
        />
        <path
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M67 75.3L49.4 53.9h11.9L43.2 31H54L37.8 8.5 21.6 31h10.8L14.3 53.9h11.9L8.6 75.3H67z"
        />
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth={3}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="M37.8 77.1V90M4.5 98.4h100"
        />
      </svg>
    );
  },
);
